import { Typography } from '@mui/material';

const countriesToHide = ['by', 'cu', 'ir', 'kp', 'ru', 'sy', 'ua'];

export default function AffiliateBox({ countryCode }) {
  if (countryCode && countriesToHide.indexOf(countryCode) !== -1) return <></>;
  return (
    <div className="tw-bg-primary-50 dark:tw-bg-primary-900 tw-h-full tw-w-full tw-px-8 tw-py-4 tw-rounded tw-mb-6">
      <Typography
        color="textPrimary"
        variant="h5"
        component="p"
        className="tw-font-bold tw-pb-3 tw-pt-2"
      >
        Don&apos;t Forget: Get Travel Health Insurance!
      </Typography>
      <p>
        To make your trip a worry-free experience, TravelFeed recommends{' '}
        <a
          href="https://safetywing.com/nomad-insurance/?referenceID=travelfeed&campaign=travel-resources&utm_source=travelfeed&utm_medium=Ambassador"
          rel="sponsored noreferrer nofollow"
          target="_blank"
        >
          SafetyWing Nomad Insurance
        </a>
        . It provides comprehensive health coverage while you travel, so you can
        focus on exploring, not the unexpected.{' '}
        <a
          href="https://safetywing.com/nomad-insurance/?referenceID=travelfeed&campaign=travel-resources&utm_source=travelfeed&utm_medium=Ambassador"
          rel="sponsored noreferrer nofollow"
          target="_blank"
        >
          Get a quote here
        </a>
      </p>
    </div>
  );
}
